/*
Create By PRATAN : 2023-05-24
Update By Sittikron : 09/08/2023  - เพิ่ม Permissionในการตรวจสอบ
Update By Sittikron : 28/08/2023 - แก้ไขสิทธิทุกหน้า ที่เรียกการใช้  สิทธิ view  เปลี่ยนวิธีเขียนใหม่  ให้เหมือนหน้า m_project.js

Update By POOM : 30/01/2024 - หน้าค้นหา User > ให้ default หน้าค้นหามาเลย เนื่องจากเดิมไม่แสดงปุ่ม new staff ต้องคลิ๊กปุ่ม search 
                              เมื่อลูกค้าต้องการเพิ่ม staff ใหม่

Update By POOM : 13/05/2024  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที

*/
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { CP_CheckPermission } from "../Class/Class_Permission"
import Pathurl from "../Class/Pathurl.json";
import { Link } from "react-router-dom";

import {
  Class_ETC_Encrypt,
  Class_ETC_MsgError,
  Class_ETC_MsgSuccess,
  Class_ETC_Warning,
  Class_ETC_SessionTimeOut
} from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import ConfigETC from "../Class/ConfigETC.json";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import PaginationActions from "../PartialView/PaginationActions";
import ChangePasswordAction from "../PartialView/ChangePasswordAction";
import { customStylesSelect } from "../Class/Class_Etc"

function M_staff() {
  //#region __ Parameter __

  const animatedComponents = makeAnimated();
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [listPermission, setListPermission] = useState([]);

  const [ActAdd] = useState(Class_ETC_Encrypt("Add"));
  const [ActEdit] = useState(Class_ETC_Encrypt("Edit"));
  const [listdata, setListdata] = useState([]);
  const [_sPermission, set_SPermission] = useState([]);

  const [page, setPage] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //

  const staff_status = [
    { value: "-1", label: ConfigETC.ddl_All },
    { value: "1", label: "active" },
    { value: "0", label: "In-active" },
  ];
  const [_sstatus, set_Sstatus] = useState(staff_status[0]);

  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionDel, setIsPermissionDel] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);

  const [max_staff, setMax_staff] = useState(0);
  const [active_staff, setActive_staff] = useState(0);


  //#endregion

  useEffect(() => {
    if (isLoadProgress === true) {
      GetConfig();
      if (isLoadedConfigData === true) {
        let ckpermission = CP_CheckPermission("master" , ["staff_view"] , false , true)
        if (ckpermission === true) {
          setIsPermissionEdit(CP_CheckPermission("master" , ["staff_edit"] , false , false))
          setIsPermissionDel(CP_CheckPermission("master" , ["staff_delete"] , false , false))
          setIsPermissionAdd(CP_CheckPermission("master" , ["staff_add"] , false , false)) 
          BindDDL(function () {
            BindService(function() {
              //setIsLoadProgress(false);
              onclickSearch();
            });
          });
        }
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      document.getElementById("Search_Staff").click();
    }
  };

  //#region __ Bind Data __
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindDDL(_callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        per_group_status: "-1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Permission_Getlist",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          const arr = [];
          json.data.map((en) => {
            return arr.push({
              value: en.per_group_id,
              label: en.per_group_name,
            });
          });
          setListPermission(arr);
        } else {
          setListPermission([]);
        }
        if (_callback != null) {
          _callback();
        }
      }else{
        setListPermission([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setListPermission([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindService(_callback) {
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = ""

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "ServiceInfo_GetDetail",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          // setMax_staff(10)
          // setActive_staff(9)
          setMax_staff(json.max_staff)
          setActive_staff(json.active_staff)
        } else {
          setMax_staff(0)
          setActive_staff(0)
        }
        if (_callback != null) {
          _callback();
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setMax_staff(0)
        setActive_staff(0)
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setMax_staff(0)
      setActive_staff(0)
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindList(isSearch = true, _callback) {
    try {
      let sPermission = "";
      if (_sPermission.length > 0) {
        for (let i = 0; i < _sPermission.length; i++) {
          sPermission =
            sPermission +
            (sPermission === "" ? "" : ",") +
            _sPermission[i].value;
        }
      }

      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        per_group_str: sPermission,
        staff_status: _sstatus.value,
        staff_search_text: document
          .getElementById("txt_search_text")
          .value.trim(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Staff_Getlist",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (isSearch) {
            setPage(0);
          } else {
            if (rowsPerPage * (page + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPage);
              setPage(pagenow === 0 ? 0 : pagenow - 1);
            }
          }
          setListdata(json.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          setPage(0);
          setListdata([]);
          if (_callback != null) {
            _callback();
          }
        }
      } 
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setPage(0);
        setListdata([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setPage(0);
      setListdata([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  //#endregion

  //#region __ Onclick __

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };

  function onclickSearch() {
    setIsLoadProgress(true);
    setIsSearch(true);
    BindService(function() {
      BindList(true,function () {
        setIsLoadProgress(false);
      });
    });
    
  }

  function onclick_DelStaff(staff_code,img_profile) {
    document.getElementById("hd_iddel").value = staff_code;
    document.getElementById("hd_img_profile").value = img_profile;
    Class_ETC_Warning(MsgDescription.CFM002, DelStaff);
  }

  function onclick_ModalShow(staff_code, Fullname) {
    document.getElementById("lbl_Modal_Staff_code").innerHTML = staff_code;
    document.getElementById("lbl_Modal_Fullname").innerHTML = Fullname;

    document.getElementById("txt_Modal_New_Password").value = "";
    document.getElementById("txt_Modal_New_Password").type = "password";
    document.getElementById("i_Modal_New_Password").className = "fa fa-eye";

    document.getElementById("txt_Modal_Confirm_New_Password").value = "";
    document.getElementById("txt_Modal_Confirm_New_Password").type = "password";
    document.getElementById("i_Modal_Confirm_New_Password").className =
      "fa fa-eye";
  }
  //#endregion

  //#region __ Function __
  async function DelStaff() {
    setIsLoadProgress(true);
    try {
      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        staff_code: document.getElementById("hd_iddel").value.trim(),
        staff_img_name: document.getElementById("hd_img_profile").value.trim(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Staff_Del",
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        BindService(function() {
          BindList(false,function(){
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
          });
        });

      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
       
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
      
    }
  }
  //#endregion

  function onclickReset(){
    set_SPermission([]); 
    set_Sstatus(staff_status[0]);
    document.getElementById("txt_search_text").value = "";
    setIsSearch(false);
};

function onChageSelectStatus(e){
  e === null ? set_Sstatus(staff_status[0]) : set_Sstatus(e) ;
}

  return (
    <>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <Helmet>
        <title>Staff list</title>
      </Helmet>

      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fa fa-user" /> Staff list{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="row">
                  <div className="col-lg-9 col-12">
                    <div className="form-group">
                      <label>Permission Group</label>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        placeholder={ConfigETC.ddl_All}
                        isMulti
                        value={_sPermission}
                        options={listPermission}
                        menuPortalTarget={document.body}
                        onChange={(e) => set_SPermission(e)}
                        //styles={{
                          //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        //}}
                        styles={customStylesSelect}
                    
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-12">
                    <div className="form-group">
                      <label>Status</label>
                      <Select
                        options={staff_status}
                        placeholder={ConfigETC.ddl_All}
                        isClearable={true}
                        menuPortalTarget={document.body}
                        value={ _sstatus}
                        defaultValue={staff_status[0]}
                        onChange={(e) => onChageSelectStatus(e)}
                        //styles={{
                          //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        //}}
                        styles={customStylesSelect}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-9 col-12">
                  <div className="form-group">
                      <input
                          id="txt_search_text"
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search by Staff Code, Fristname or ... "
                        />
                    </div>
                  </div>
                  <div className="col-lg-3 col-12">
                        <div className="form-group m-0 mb-2">
                            <div >
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-sm"
                                    id="Search_Staff"
                                    onClick={onclickSearch}
                                  >
                                    <i className="fas fa-search" /> Search
                                  </button>&nbsp;
                                <button type="button" className="btn btn-default btn-sm" onClick={onclickReset}>
                                    <i className="fas fa-times"></i> reset
                                </button>

                            </div>

                        </div>
                  </div>
                </div>
               
              </div>
            </div>

            {isSearch && (
              <>
                <div className="row">
                  <div className="col-md-12 ">
                    {/* SELECT2 EXAMPLE */}
                    <div className="card  shadow">
                      <div className="card-header ">
                        <h3 className="card-title">
                          Result <small> ({listdata.length} users)</small>
                        </h3>

                        <div className="float-right">
                          <div className="btn-group">
                        
                              {((isPermissionAdd === true) && (active_staff < max_staff)) &&                                  
                                <Link
                                  to={"../" + Pathurl.m_staff_ae}
                                  state={{ staff_code: Class_ETC_Encrypt("0"), act: ActAdd }}
                                  className="btn btn-primary btn-sm"
                                >
                                  <i className="fa fa-plus" /> New Staff
                                </Link>                                   
                              }
                          </div>
                        </div>
                        
                      </div>
                      <div className="card-body p-0">
                        <input type="hidden" id="hd_iddel"></input>
                        <input type="hidden" id="hd_img_profile"></input>
                        <TableContainer>
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            className="table table-head-fixed text-nowrap table-hover"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell width={"5%"} align={"left"}>
                                  <b>#</b>
                                </TableCell>
                                <TableCell width={"15%"} align={"left"}>
                                  <b>Staff Code</b>
                                </TableCell>
                                <TableCell width={"20%"} align={"left"}>
                                  <b>Fullname(Th)</b>
                                </TableCell>
                                <TableCell width={"20%"} align={"left"}>
                                  <b>Fullname(Eng)</b>
                                </TableCell>
                                <TableCell width={"18%"} align={"left"}>
                                  <b>Permission Group</b>
                                </TableCell>
                                <TableCell width={"10%"} align={"left"}>
                                  <b>Status</b>
                                </TableCell>
                                <TableCell
                                  width={"12%"}
                                  align={"left"}
                                ></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(listdata.length === 0 && (
                                <TableRow key={1}>
                                  <TableCell colSpan={7} align="center">
                                    {ConfigETC.NoData}
                                  </TableCell>
                                </TableRow>
                              )) ||
                                listdata
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                                    <TableRow key={row.staff_code}>
                                      <TableCell>
                                        <div>{row.rowindex}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>
                                          
                                          {row.staff_img_profile === "" && (
                                            <>
                                              <div
                                                className="img-circle img-size-32 mr-2 img-bordered-sm bg-gray text-center"
                                                style={{
                                                  display: "inline-block",
                                                }}
                                              >
                                                <i className="fa"> {row.staff_tag_profile} </i>
                                              </div> 
                                            </>
                                          )}

                                          {row.staff_img_profile !== "" && (
                                            <>
                                              <img src={row.staff_img_profile} alt={row.staff_code}
                                                className="img-circle img-size-32 mr-2"
                                              ></img>
                                            </>
                                          )}
                                          <b>{row.staff_code}</b>
                                        </div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>{row.staff_fullnameTh}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>{row.staff_fullnameEng}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>{row.per_group_str}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>
                                          <span
                                            className={
                                              row.staff_status === 1
                                                ? ConfigETC.Status_active
                                                : ConfigETC.Status_inactive
                                            }
                                          >
                                            {row.staff_status_str}
                                          </span>
                                        </div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div className="btn-group btn-group-sm">
                                          <Link
                                            to={"../" + Pathurl.m_staff_ae}
                                            state={{
                                              staff_code: Class_ETC_Encrypt(
                                                row.staff_code
                                              ),
                                              act: ActEdit,
                                            }}
                                            className="btn btn-primary btn-sm"
                                          >
                                            <i className="fas fa-pencil-alt" />
                                          </Link>
                                          {(isPermissionEdit === true) &&
                                            <a
                                              href="#!"
                                              className="btn btn-default btn-sm"
                                              data-target="#modal-change-pass"
                                              data-toggle="modal"
                                              onClick={() =>
                                                onclick_ModalShow(
                                                  row.staff_code,
                                                  row.staff_fullnameEng
                                                )
                                              }
                                            >
                                              <i className="fas fa-key" />
                                            </a>
                                          }
                                          {(isPermissionDel === true) &&
                                            <a
                                              href="#!"
                                              onClick={() =>
                                                onclick_DelStaff(row.staff_code,row.staff_img_profile_str)
                                              }
                                              className="btn btn-default btn-sm"
                                            >
                                              <i className="fas fa-trash" />
                                            </a>
                                          }
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {listdata.length > 0 && (
                          <TablePagination
                            rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                            component="div"
                            count={listdata.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={PaginationActions}
                          />
                        )}
                      </div>
                      {/* /.card-body */}
                    </div>
                    {/* /.card */}
                  </div>
                </div>
              </>
            )}
            
            {/* /.row (main row) */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}

      <ChangePasswordAction Act={"edit"}/>
    </>
  );
}

export default M_staff;
